import {
  CREATE_TUTORIAL,
  RETRIEVE_TUTORIALS,
  UPDATE_TUTORIAL,
  DELETE_TUTORIAL,
  DELETE_ALL_TUTORIALS,
} from "../actions/types";

const initialState = [];

function tutorialReducer(tutorials = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    // retrieving all we need is to read, we just get the list from a payload.
    case RETRIEVE_TUTORIALS:
      return payload;

    // when we change state we do not mutate, we instead spread state in
    // then we change the next thing, in this case it is whatever payload
    // provides us also being spread in.

    // creating adds an object to an array of objects, while preserving the list.
    case CREATE_TUTORIAL:
      return [...tutorials, payload];

    // updating things is similar but on the object level, as we map through
    // the existing tutorials we check if the id matches the payload id
    // if so we know we have the specific tutorial we want to update, so we return it
    // but not before we spread it what it used to be and then change one field
    // naturally with the payload information that is being changed, i.e. updating
    // when we do not match id we still need that data, and it is not changing here
    // so all we have to do is return it.
    case UPDATE_TUTORIAL:
      return tutorials.map((tutorial) => {
        if (tutorial.id === payload.id) {
          return {
            ...tutorial,
            ...payload,
          };
        } else {
          return tutorial;
        }
      });

    // deleting is similar to updating but we do not need to preserve anything
    // so we can just filter the array of objects for id, returning the list without
    // that specific tutorial.
    case DELETE_TUTORIAL:
      return tutorials.filter(({ id }) => id !== payload.id);

    // deleting all the tutorials is also easy, just return an empty list
    case DELETE_ALL_TUTORIALS:
      return [];

    // default is if not any option just return the list as it is.
    default:
      return tutorials;
  }
}

export default tutorialReducer;
